import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import { Tooltip } from 'antd';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';
import { useCopy } from '~/hooks/clipboard';
import styled from 'styled-components';

function emailCell(visibleColumns: any) {
  if (!visibleColumns.includes('email')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Email', { ns: 'sales' })} />,
    dataIndex: ['email'],
    key: 'email',
    render: (email: any) => <EmailDisplay email={email} />,
    width: 200,
  };
}

const EmailDisplay = ({ email }: { email?: string }) => {
  const copy = useCopy();

  if (!email) return <CellText>-</CellText>;

  return (
    <Tooltip title={`Click to copy: ${email}`}>
      <ClickableContainer
        onClick={(e) => {
          void copy(email);
          e.preventDefault();
        }}
      >
        <CellText>{email}</CellText>
      </ClickableContainer>
    </Tooltip>
  );
};

const ClickableContainer = styled.div`
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
  }
`;

export default emailCell;
